import React, { useState } from 'react';
import CSwitch from '../../../../../migration/CSwitch';
import { CLink } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { callCompressTokenApi } from '../../../../../../apiCaller';
import { useDispatch, useSelector } from 'react-redux';
import { CLIENT_SCHEDULE_SAVED_REPORT } from '../../../../../../constants';
import { setSavedReport, setScheduleSavedReport } from '../../../../../../actions/subscriber';
import { toastError } from '../../../../../../utils';
import { ConfirmRemovePopup } from '../../../../../general/popup';
import { toast } from 'react-toastify';
import Tippy from '@tippyjs/react';

const ScheduleCard = ({ savedReports, scheduleIndex, schedule, setShowCreate }) => {
     const schedules = useSelector((state) => state.subscriber.scheduleSavedReport) || [];
     const [showDelete, setShowDelete] = useState(false);

     const dispatch = useDispatch();

     const onClickEdit = (id) => {
          setShowCreate({ show: true, id });
     };

     const onClickDelete = async (schedule) => {
          const data = {
               id: schedule.id,
               accountId: schedule.accountId,
               reportViewId: schedule.reportViewId,
          };
          callCompressTokenApi(CLIENT_SCHEDULE_SAVED_REPORT, 'DELETE', data)
               .then((response) => {
                    if (response.status === 200) {
                         const newSchedules = [...schedules].filter((item) => item.id !== data.id);
                         const updatedSavedReport = savedReports.map((report) => {
                              let totalSchedule = report.totalSchedule || 0;
                              if(report.id === schedule.reportViewId) {
                                   totalSchedule = totalSchedule - 1
                              }
                              return { ...report, totalSchedule }
                         })
                         dispatch(setScheduleSavedReport(newSchedules));
                         dispatch(setSavedReport(updatedSavedReport));
                         toast.success('schedule is deleted!');
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setShowDelete(false);
               });
     };

     const onClickToggleStatus = (schedule) => {
          const data = {
               id: schedule.id,
               accountId: schedule.accountId,
               reportViewId: schedule.reportViewId,
               status: !schedule.status,
          };
          callCompressTokenApi(CLIENT_SCHEDULE_SAVED_REPORT, 'PUT', data)
               .then((response) => {
                    if (response.status === 200) {
                         const { schedule } = response.data;
                         const newSchedules = schedules.map((item) => {
                              if (item.id === schedule.id) {
                                   return { ...item, ...schedule };
                              }
                              return item;
                         });
                         dispatch(setScheduleSavedReport(newSchedules));
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {});
     };

     const formatSpecificDayLabel = (specificDay) => {
         let str = specificDay;
         if (str !== 'First Monday') str = specificDay + ' Day';
         return `On ${str} of the Month`;
     };

     const desTooltipSchedule = () => {
          const SPECIFIC_DAY = {
               first: 'First',
               last: 'Last',
               firstMonday: 'First Monday',
          };
          let content = '';
          switch (schedule.schedule) {
               case 'daily':
                    content = 'Everyday.';
                    break;
               case 'weekly':
                    content = `Every ${schedule.daysOfWeek.join(', ')}.`;
                    break;
               case 'monthly':
                    content = formatSpecificDayLabel(SPECIFIC_DAY[schedule.specificDay]);
                    break;
               case 'quarterly':
                    content = `On ${SPECIFIC_DAY[schedule.specificDay]} Day of the Quarter.`;
                    break;
               default:
                    break;
          }

          return content;
     };

     return (
          <>
               <div index={scheduleIndex} className='row-rule d-flex justify-content-between'>
                    <div className='info-wrap d-flex justify-content-between align-items-center'>
                         <div className='info-title'>
                              <h4>{schedule.name}</h4>
                              <div className='d-inline-flex'>
                                   {schedule.id && (
                                        <div className='tooltip-schedule-card'>
                                             <Tippy
                                                  content={
                                                       <div className='block-tooltip-text email-block-tooltip'>
                                                            <span>Delivery Schedule: {desTooltipSchedule()}</span>
                                                            <div className='email-list-tooltip'>
                                                                 <span>Recipients:</span>
                                                                 <ul>
                                                                      {schedule.emailList.map((email) => {
                                                                           return <li>{email}</li>;
                                                                      })}
                                                                 </ul>
                                                            </div>
                                                       </div>
                                                  }
                                                  interactive="true"
                                             >
                                                  <CIcon icon='icon-info' height={14} />
                                             </Tippy>
                                        </div>
                                   )}
                              </div>
                         </div>
                    </div>
                    <div className='options-wrapper d-flex'>
                         <div className='option-item hover-show-tooltip'>
                              <Tippy
                                   content={
                                        <div className='block-tooltip-text'>
                                             <span>Edit Schedule</span>
                                        </div>
                                   }
                              >
                                   <CLink className='option text-primary' onClick={() => onClickEdit(schedule.id)}>
                                        <CIcon icon='icon-pencil' height={14} />
                                   </CLink>
                              </Tippy>
                         </div>
                         <div className='option-item hover-show-tooltip'>
                              <Tippy
                                   content={
                                        <div className='block-tooltip-text'>
                                             <span>Delete Schedule</span>
                                        </div>
                                   }
                              >
                                   <CLink className='option option-item-delete' onClick={() => setShowDelete(true)}>
                                        <CIcon icon='iconDeleteField' className='icon-delete pointer' />
                                   </CLink>
                              </Tippy>
                         </div>

                         <div className='option-item switch-item hover-show-tooltip'>
                              <Tippy
                                   content={
                                        <div className='block-tooltip-text'>
                                             <span>{schedule.status ? 'Disable' : 'Enable'}</span>
                                        </div>
                                   }
                              >
                                   <span className='option'>
                                        <CSwitch
                                             color={schedule.status ? 'success' : 'light'}
                                             checked={!!schedule.status}
                                             value={schedule.status ? 'on' : 'off'}
                                             shape='pill'
                                             tabIndex='0'
                                             size='sm'
                                             onChange={() => onClickToggleStatus(schedule)}
                                        />
                                   </span>
                              </Tippy>
                         </div>
                    </div>
               </div>
               <ConfirmRemovePopup
                    show={showDelete}
                    onAccept={() => onClickDelete(schedule)} // Pass a function reference
                    onClose={() => setShowDelete(false)}
               >
                    <p>
                         You are about to delete the Schedule "<strong>{schedule.name}</strong>".
                    </p>
               </ConfirmRemovePopup>
          </>
     );
};

export default ScheduleCard;
